import CryptoJS from 'crypto-js';
import { get } from 'lodash';
import { FullStoryAPI } from 'react-fullstory';
import { handleActions } from 'redux-actions';
import { actions as usersActions } from 'services/users/duck';

const identifyFullStoryUser = (state, action) => {
    const { payload } = action;
    if ('FS' in window && payload) {
        // https://help.fullstory.com/develop-js/identify
        // First, generate UID, one that is not idetifieable to the user and
        // gauranteed to be unique. Once `identify` is set, it cannot be changed.
        const { config } = action.getState();
        const secret = get(config, 'env.REACT_APP_FULLSTORY_SECRET', null);

        // Without secret key, do not track. This will cause tracking mismatches.
        if (!secret) {
            console.warn('FullStory not properly configured.'); // eslint-disable-line no-console
            return true;
        }

        // Generate UID
        const hash = CryptoJS.HmacSHA256([payload.id, payload.email].join(':'), secret);
        const uid = CryptoJS.enc.Base64.stringify(hash);

        // https://help.fullstory.com/develop-js/setuservars
        FullStoryAPI('identify', uid, {
            // FullStory System Fields
            email: payload.email,
            displayName: payload.fullName,
            // FullStory Custom Fields
            userId_int: payload.id,
            isOkta_bool: payload.isOkta
        });
    }
    return true;
};

export default handleActions({
    [usersActions.FETCH_CURRENT_USER_SUCCESS]: identifyFullStoryUser
}, {});



// WEBPACK FOOTER //
// ./src/services/fullstory/duck.js